import ClusterHubPage from '../../components/ClusterHubPage';
import { CLUSTERS } from '../../data/clusterConfig';
export default function DikkatOdakTestleriHub() {
  return <ClusterHubPage cluster={CLUSTERS['dikkat-ve-odak-testleri']} />;
}
